export default __webpack_public_path__ + "static/media/fall_back-menu.f8a8d7e1.svg";